const inputClass = (hasError) =>
  `w-full px-4 py-3 bg-white border rounded text-sm text-[#00163E] placeholder:text-[#8A9BB1]/60 outline-none transition-colors duration-200 ${
    hasError ? 'border-red-400 focus:border-red-500' : 'border-[#E4E6EA] focus:border-[#C58C40]'
  }`;

const labelClass = 'block text-sm font-medium text-[#00163E] mb-1.5';
const errorClass = 'text-red-500 text-xs mt-1';

const EXPERIENCIA = ['5–10 años', '10–15 años', '15–20 años', '+20 años'];
const SITUACION_PROFESIONAL = [
  'Autónomo / profesional por cuenta propia',
  'Trabajador por cuenta ajena',
  'En desempleo',
];

export default function StepIdentidad({ data, errors, onChange }) {
  return (
    <div className="space-y-5">
      <p className="text-[#8A9BB1] text-sm mb-2">
        Comenzamos verificando su trayectoria.
      </p>

      {/* Nombre + Email */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className={labelClass}>Nombre completo</label>
          <input
            type="text"
            value={data.nombre}
            onChange={(e) => onChange('nombre', e.target.value)}
            placeholder="Nombre y apellidos"
            data-testid="adv-field-nombre"
            className={inputClass(errors.nombre)}
          />
          {errors.nombre && <p className={errorClass}>{errors.nombre}</p>}
        </div>
        <div>
          <label className={labelClass}>Correo electrónico profesional</label>
          <input
            type="email"
            value={data.email}
            onChange={(e) => onChange('email', e.target.value)}
            placeholder="correo@profesional.com"
            data-testid="adv-field-email"
            className={inputClass(errors.email)}
          />
          {errors.email && <p className={errorClass}>{errors.email}</p>}
        </div>
      </div>

      {/* Teléfono + LinkedIn */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className={labelClass}>Teléfono</label>
          <input
            type="tel"
            value={data.telefono}
            onChange={(e) => onChange('telefono', e.target.value)}
            placeholder="+34 600 000 000"
            data-testid="adv-field-telefono"
            className={inputClass(errors.telefono)}
          />
          {errors.telefono && <p className={errorClass}>{errors.telefono}</p>}
        </div>
        <div>
          <label className={labelClass}>LinkedIn</label>
          <input
            type="url"
            value={data.linkedin}
            onChange={(e) => onChange('linkedin', e.target.value)}
            placeholder="https://linkedin.com/in/su-perfil"
            data-testid="adv-field-linkedin"
            className={inputClass(errors.linkedin)}
          />
          {errors.linkedin && <p className={errorClass}>{errors.linkedin}</p>}
          <p className="text-[#8A9BB1] text-xs mt-1.5">
            Verificamos personalmente cada trayectoria declarada.
          </p>
        </div>
      </div>

      {/* Cargo + Empresa */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className={labelClass}>Cargo actual</label>
          <input
            type="text"
            value={data.cargoActual}
            onChange={(e) => onChange('cargoActual', e.target.value)}
            placeholder="Ej.: CEO, Director General, Consejero, Socio"
            data-testid="adv-field-cargo"
            className={inputClass(errors.cargoActual)}
          />
          {errors.cargoActual && <p className={errorClass}>{errors.cargoActual}</p>}
        </div>
        <div>
          <label className={labelClass}>
            Empresa actual <span className="text-[#8A9BB1] font-normal">(opcional)</span>
          </label>
          <input
            type="text"
            value={data.empresaActual}
            onChange={(e) => onChange('empresaActual', e.target.value)}
            placeholder="Nombre de la empresa"
            data-testid="adv-field-empresa"
            className={inputClass(errors.empresaActual)}
          />
          {errors.empresaActual && <p className={errorClass}>{errors.empresaActual}</p>}
        </div>
      </div>

      {/* Experiencia */}
      <div>
        <label className={labelClass}>Años de experiencia total</label>
        <div className="flex flex-wrap gap-2 mt-1">
          {EXPERIENCIA.map((e) => (
            <button
              key={e}
              type="button"
              onClick={() => onChange('experiencia', e)}
              data-testid={`adv-field-exp-${e}`}
              className={`px-5 py-2.5 text-sm rounded border transition-all duration-200 ${
                data.experiencia === e
                  ? 'border-[#C58C40] bg-[#C58C40]/10 text-[#C58C40]'
                  : 'border-[#E4E6EA] text-[#00163E]/60 hover:border-[#00163E]/30'
              }`}
            >
              {e}
            </button>
          ))}
        </div>
        {errors.experiencia && <p className={errorClass}>{errors.experiencia}</p>}
      </div>

      {/* Situación profesional actual */}
      <div>
        <label className={labelClass}>Situación profesional actual</label>
        <div className="flex flex-wrap gap-2 mt-1">
          {SITUACION_PROFESIONAL.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => onChange('situacionProfesional', s)}
              data-testid={`adv-field-situacion-${s}`}
              className={`px-5 py-2.5 text-sm rounded border transition-all duration-200 ${
                data.situacionProfesional === s
                  ? 'border-[#C58C40] bg-[#C58C40]/10 text-[#C58C40]'
                  : 'border-[#E4E6EA] text-[#00163E]/60 hover:border-[#00163E]/30'
              }`}
            >
              {s}
            </button>
          ))}
        </div>
        <p className="text-[#8A9BB1] text-xs mt-2">
          Nos permite preparar la forma de colaboración adecuada en cada caso.
        </p>
        {errors.situacionProfesional && <p className={errorClass}>{errors.situacionProfesional}</p>}
      </div>
    </div>
  );
}
